document.addEventListener("DOMContentLoaded", function(event) {
  const sliderBlue = document.querySelectorAll('.lp-blue-slider');
  console.log(sliderBlue);

  sliderBlue.forEach((slider) => {
    const labels = slider.querySelectorAll('.lp-blue-slider__nav-item');
    const sliderNav = slider.querySelector('.lp-blue-slider__navigation-slider');
    const mainSlider = slider.querySelector('.lp-blue-slider__wrapper-slider');

    if ( labels ) {
      labels[0].classList.add('lp-blue-slider__nav-item--active')
    }

    const thumbsSwiper = new Swiper(sliderNav, {
      direction: 'horizontal',
      slidesPerView: 10,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      wrapperClass: 'lp-blue-slider__navigation',
    });

    const swiper = new Swiper(mainSlider, {
      direction: 'horizontal',
      spaceBetween: 10,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.lp-blue-slider__slider-arrow--next',
        prevEl: '.lp-blue-slider__slider-arrow--prev',
      },
      thumbs: {
        swiper: thumbsSwiper
      },
      breakpoints: {
        1200: {
          autoHeight: false,
        }
      }
    });


    swiper.on('slideChange', function() {
      const activeIndex = swiper.realIndex;
      const thumbs = slider.querySelectorAll('.lp-blue-slider__navigation .swiper-slide');
      thumbs.forEach((thumb, index) => {
        if (index === activeIndex) {
          thumb.classList.add('lp-blue-slider__nav-item--active');
        } else {
          thumb.classList.remove('lp-blue-slider__nav-item--active');
        }
      });
    });
  });
});